import request from '@/utils/request'

export function listClasses(courseId) {
  return request({
    url: '/couse-class',
    method: 'get',
    params: { courseId }
  })
}

export function myClasses(repoId) {
  return request({
    url: '/couse-class/my',
    method: 'get',
    params: repoId ? { repoId } : {}
  })
}

export function createClass(data) {
  return request({
    url: '/couse-class',
    method: 'post',
    data
  })
}

export function updateClass(id, data) {
  return request({
    url: `/couse-class/${id}`,
    method: 'put',
    data
  })
}

export function deleteClass(id) {
  return request({
    url: `/couse-class/${id}`,
    method: 'delete'
  })
}

export function addStudentByUsername(classId, username) {
  return request({
    url: `/couse-class/${classId}/add-student`,
    method: 'post',
    params: { username }
  })
}

export function addStudentById(classId, userId) {
  return request({
    url: `/couse-class/${classId}/add-student-by-id`,
    method: 'post',
    params: { userId }
  })
}

export function joinByInviteCode(inviteCode) {
  return request({
    url: '/couse-class/join',
    method: 'post',
    data: { inviteCode }
  })
}

export function listStudents(classId) {
  return request({
    url: `/couse-class/${classId}/students`,
    method: 'get'
  })
}

export function removeStudent(classId, userId) {
  return request({
    url: `/couse-class/${classId}/student/${userId}`,
    method: 'delete'
  })
}

export function getClassById(id) {
  return request({
    url: `/couse-class/${id}`,
    method: 'get'
  })
}
